module.exports = "https://cdn-skillquest.mathletics.com/app/174/assets/images/f65da4a6cbb8daa615422ce7ee38d9b4.svg";